export default __webpack_public_path__ + "static/media/dog1.6262c477.JPG";